import type { RaspadinhaDayWinningSchedule } from '@/types/raspadinha-campaign'
import { collectCampaignWinners } from './collect-campaign-winners'
import { buildCampaignCsvFilename, csvEscape, downloadCsvFile } from './csv-export-utils'
import { formatReceiptSignedAt, getWinnerPrizeReceiptSignature } from './winner-receipt-signature'
import { formatWinningTimeLabel } from './date-winning-schedules'

export const CAMPAIGN_WINNERS_CSV_HEADER = [
  'Data',
  'Horário',
  'Status do horário',
  'Nome',
  'CPF / documento',
  'Prêmio',
  'Observações',
  'Hash da assinatura',
  'IP da assinatura',
  'Data e hora da assinatura',
  'ID interno',
] as const

export function buildCampaignWinnersCsv(schedules: RaspadinhaDayWinningSchedule[]): string {
  const rows = collectCampaignWinners(schedules)

  const lines = [
    CAMPAIGN_WINNERS_CSV_HEADER.join(','),
    ...rows.map((row) => {
      const receipt = getWinnerPrizeReceiptSignature(row.winner)

      return [
        csvEscape(row.dateLabel),
        csvEscape(formatWinningTimeLabel(row.slotTime)),
        csvEscape(row.slotIsActive ? 'Ativo' : 'Inativo'),
        csvEscape(row.winner.name),
        csvEscape(row.winner.document),
        csvEscape(row.winner.prize_label),
        csvEscape(row.winner.notes),
        csvEscape(receipt.hash),
        csvEscape(receipt.ip_address),
        csvEscape(formatReceiptSignedAt(receipt.signed_at)),
        csvEscape(row.winner.id),
      ].join(',')
    }),
  ]

  return lines.join('\r\n')
}

export function buildCampaignWinnersCsvFilename(campaignSlug: string): string {
  return buildCampaignCsvFilename('ganhadores', campaignSlug)
}

export function downloadCampaignWinnersCsv(
  schedules: RaspadinhaDayWinningSchedule[],
  filename: string
): void {
  downloadCsvFile(buildCampaignWinnersCsv(schedules), filename)
}
